import { DataModelBuilder, SerializationContext, SerializedData } from '../../models/dto/data-model.js';
import { isSameData } from '../../models/dto/data-model-utils.js';
import { BackstageEvent } from '../../models/serializable/backstage-event.js';
import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';

export class BackstageEventComponent extends Component {
  static readonly TYPE_ID: string = 'b4d8d90de71d4dcca0b004da29385057';

  private constructor(
    public readonly event: BackstageEvent,
  ) {
    super();
  }

  get $typeId(): string {
    return BackstageEventComponent.TYPE_ID;
  }

  get $removable(): boolean {
    return false;
  }

  static create(args: {
    event: BackstageEvent,
  }): BackstageEventComponent {
    return new BackstageEventComponent(
        args.event,
    );
  }

  static fromMap(
      context: SerializationContext,
      map: SerializedData,
  ): BackstageEventComponent {
    return new BackstageEventComponent(
        context.fromData<BackstageEvent>(MapUtils.get<SerializedData>(map, 'event')),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      event: context.toData(this.event),
    };
  }

  clone(): this {
    return new BackstageEventComponent(
        this.event.clone(),
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return isSameData(other.event, this.event);
  }
}

export class BackstageEventComponentBuilder extends DataModelBuilder<BackstageEventComponent> {
  build(context: SerializationContext, map: SerializedData): BackstageEventComponent {
    return BackstageEventComponent.fromMap(context, map);
  }
}
